var $9be03138870991df$exports = {};
$9be03138870991df$exports = {
    "backButton": (args)=>`Vissza ide: ${args.prevMenuButton}`,
    "moreActions": `Tov\xe1bbi lehet\u{151}s\xe9gek`,
    "unavailable": `Nem \xe9rhet\u{151} el, a r\xe9szletek\xe9rt bontsa ki`
};


export {$9be03138870991df$exports as default};
//# sourceMappingURL=hu-HU.module.js.map
